import React, { useState, useEffect } from "react";
import NutritionReport from "./Nutrition/NutritionReport";
import EconomyReport from "./Economy/EconomyReport";
import EnvironmentReport from "./Environment/EnvironmentReport";
import "./ReportStyle.css";

const WholeSection = ({ inventory, trash }) => {
  const [mode, setMode] = useState("inventory");

  const handleSetMode = () => {
    if (mode === "inventory") {
      setMode("trash");
    } else {
      setMode("inventory");
    }
  };

  return (
    <div className="reportBody">
      <h4 className="reportTitle">Entire {mode}</h4>
      <button id="reportModeBtn" onClick={() => handleSetMode()}>
        {mode === "inventory" ? "set trash" : "set inventory"}
      </button>
      {mode === "inventory" ? (
        <React.Fragment>
          {" "}
          <EconomyReport list={inventory} />
          <NutritionReport list={inventory} />
          <EnvironmentReport list={inventory} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <EconomyReport list={trash} />
          <NutritionReport list={trash} />
          <EnvironmentReport list={trash} />
        </React.Fragment>
      )}
    </div>
  );
};

export default WholeSection;
